<template>
    <form @submit="onSubmit($event)">
        <div class="row">
            <div class="col-12">
                <p>Username: <strong>{{ form.username }}</strong></p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 form-group">
                <label class="font-sm">Password</label>
                <i class="material-icons">lock</i>
                <input name="password" type="password" class="form-control input-style"
                       v-model="form.password"
                       :disabled="loading"
                       aria-describedby="Password">
                <p class="help text-danger margin-0" v-if="$v.form.password.$error">Your password must be at least 6 characters long.</p>
            </div>
            <div class="col-12 col-md-6 form-group">
                <label class="font-sm">Confirm Password</label>
                <i class="material-icons">lock</i>
                <input name="password_confirmation" type="password" class="form-control input-style"
                       v-model="form.password_confirmation"
                       :disabled="loading"
                       aria-describedby="Password">
                <p class="help text-danger margin-0" v-if="$v.form.password_confirmation.$error">Your password should match.</p>
            </div>
        </div>
        <div class="row margin-top-20 margin-bottom-20 justify-content-center">
            <div class="col-auto">
                <button type="submit" class="btn btn-primary btn-lg text-uppercase" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{ submitButtonText }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required, minLength, sameAs} from 'vuelidate/lib/validators'

    export default {
        mixins: [validationMixin],

        props: {
            form: {
                required: true
            },
            loading: {
                required: true,
            },
            submitButtonText: {
                required: true
            },
        },

        methods: {
            onSubmit(e) {
                e.preventDefault();

                if (this.$v.form.$invalid)
                {
                    this.$v.form.$touch();

                    return;
                }

                this.$emit('submit', this.form);
            }
        },

        mounted() {

        },

        validations: {
            form: {
                password: {required, minLength: minLength(6)},
                password_confirmation: {required, sameAs: sameAs('password')}
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    .form {
        padding: 35px
    }
</style>